export function CraneMarkDefs() {
  return (
    <svg width="0" height="0" style={{ position: "absolute" }}>
      <defs>
        <g id="crane-mark">
          <path fill="#000000" d="M 201.167969 139.3125 L 190.265625 86.183594 L 249.746094 161.109375 L 201.164062 139.3125 Z" />
          <path fill="#c61f27" d="M 249.746094 161.109375 L 228.207031 125.339844 L 286.011719 117.4375 L 249.746094 161.109375 Z" />
          <path fill="#000000" d="M 286.011719 117.4375 L 297.710938 131.617188 L 277.445312 127.75 L 286.011719 117.4375 Z" />
          <path fill="#c61f27" d="M 201.167969 139.3125 L 172.402344 160.941406 L 249.742188 161.109375 L 201.164062 139.3125 Z" />
          <path fill="#e72734" d="M 201.167969 139.3125 L 215.058594 74.285156 L 249.746094 161.109375 L 201.167969 139.3125 Z" />
        </g>
      </defs>
    </svg>
  );
}

export function CraneMark({ viewBox = "150 60 170 120", className }) {
  return (
    <svg viewBox={viewBox} className={className}>
      <use href="#crane-mark" />
    </svg>
  );
}
